import { Environment } from './environment.interface';

export const environment: Environment = {
  production: true,
  clientId: "2773CE12-D60D-4CFB-90A6-AFC8C0D86D94",
  apiUris: {
    companyApiUri: "https://company-design.promob.com/api",
    chartsApiUri: "https://summary-connect.promob.com/api",
    projectsApiUri: "https://api-connect.promob.com/api",
    identitiesApiUri: "https://api.promob.com/v1/Identities",
    connectSettings: "https://func-connect-settings-prod-eastus2-001.azurewebsites.net/api"
  }
};